import React from 'react';
import { useHistory } from 'react-router';

import { Panel } from '../common/panel/Panel.component';
import { Button, Colors } from '../legacy/button/Button.component';
import { Checkbox } from '../legacy/checkbox/Checkbox.component';
import { Input, InputType } from '../legacy/input/Input.component';
import styles from './Login.module.css';

interface Props {
  onSignOutPress?: () => void;
  onLoginPress?: (input: {
    login: string;
    password: string;
    rememberMe: boolean;
  }) => void;
}

export const LoginComponent: React.FC<Props> = props => {
  const [password, setPasword] = React.useState('');
  const [login, setLogin] = React.useState('');
  const [rememberMe, setRememberMe] = React.useState(false);

  const history = useHistory();

  const handlePasswordChange = React.useCallback((value: string) => {
    setPasword(value || '');
  }, []);
  const handleLoginChange = React.useCallback((value: string) => {
    setLogin(value || '');
  }, []);

  const goToSignUp = () => {
    history.push('/register');
  };

  const toggleRememberMeChange = React.useCallback(() => {
    setRememberMe(!rememberMe);
  }, [rememberMe, setRememberMe]);

  return (
    <div className={styles.loginContainer}>
      <Panel className={styles.loginForm} title="Welcome Back!">
        <div className={styles.loginInput}>
          <div>
            <Input
              type={InputType.TEXT}
              label="Email Address or Username"
              value={login}
              onChange={handleLoginChange}
            />
          </div>

          <div>
            <Input
              type={InputType.PASSWORD}
              label="Password"
              value={password}
              onChange={handlePasswordChange}
            />
          </div>
          <Checkbox
            label="Remember me"
            checked={rememberMe}
            onClick={toggleRememberMeChange}
          />
        </div>

        <Button
          color={Colors.COLOR_SCHEME_2}
          className={styles.loginAction}
          disabled={!login || !password}
          onClick={() => {
            if (login && password) {
              props.onLoginPress?.({ login, password, rememberMe });
            }
          }}
        >
          Login
        </Button>
      </Panel>
      <p className={styles.signUpLabel}>Don't have an Account?</p>
      <Button
        color={Colors.COLOR_SCHEME_3}
        className={styles.signUpButton}
        onClick={goToSignUp}
      >
        Sign Up
      </Button>

      <Button
        color={Colors.COLOR_SCHEME_4}
        className={styles.loginAction}
        disabled={false}
        onClick={() => {
          history.push('/reset-password');
        }}
      >
        Forgot Password?
      </Button>
    </div>
  );
};
